import { AsyncThunkOptions } from '@reduxjs/toolkit'
import isEqual from 'lodash/isEqual'
import { AppThunkApiConfig } from 'reduxTyped'
import { createSelectorCreator, defaultMemoize } from 'reselect'

import { MarkupOptions } from 'utils/services/errorTrackingService/interfaces/MarkupOptions'

import { createAsyncAction, CreateAsyncActionOptions, type ThunkAPI } from './createAsyncAction'

export const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual)

export const makeCreateAsyncAction =
  (errorMarkupOptions: MarkupOptions) =>
  <Returned, ThunkArg = void>(
    typePrefix: string,
    actionCreator: (args: ThunkArg, thunkAPI: ThunkAPI) => Promise<Returned> | Returned,
    options?: CreateAsyncActionOptions<ThunkArg> & AsyncThunkOptions<ThunkArg, AppThunkApiConfig>,
  ) =>
    createAsyncAction(typePrefix, actionCreator, {
      errorMarkupOptions,
      ...options,
    })

export { createAsyncAction }
